<!-- @format -->

<template>
	<disabled-text v-if="disabled && showDisabledText" :value="value" />
	<el-input
		v-else
		v-model="value"
		:disabled="disabled"
		:type="iType"
		clearable
		show-word-limit
		:show-password="iShowPassword"
		v-bind="$attrs"
	/>
</template>

<script setup lang="ts">
	import DisabledText from './disabledText.vue';

	interface Props {
		modelValue: string;
		disabled?: boolean;
		showDisabledText?: boolean;
		type?: string;
		showCrypto?: boolean;
		showPassword?: boolean;
		isCrypto?: boolean;
		isText?: boolean;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: '',
		showDisabledText: true,
	});

	const emit = defineEmits(['update:modelValue']);

	const value = computed({
		get() {
			return props.modelValue;
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});

	const iType = computed(() => (props.isCrypto ? 'password' : props.isText ? 'text' : ''));

	const iShowPassword = computed(() => props.showCrypto || props.showPassword);
</script>

<style scoped></style>
